
import { Component, Emit, Prop } from 'vue-property-decorator'
import SortableCaret from '@/components/sortable-caret/index.vue'
import SortMenu from '@/entities/sort-menu'
import AbpBase from '@/lib/abpbase'
import config from '@/config'

@Component({
  components: { SortableCaret }
})
export default class extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'SortableItem'

  @Prop({
    type: Object,
    default: () => {}
  })
  item: SortMenu

  @Emit('sort-by')
  doSort() {
    let idx = config.sortableList.findIndex(t => t === this.item.sort)
    if (idx < 0) {
      return
    }
    return config.sortableList[(idx + 1) % config.sortableList.length]
  }
}
